<template>
  <el-dialog
    :center="true"
    :close-on-click-modal="false"
    title="角色权限配置"
    :visible.sync="roleShow"
    width="50%"
    @close="closeEditDialog"
  >
    <el-form>
      <el-row>
        <el-col :span="12">
          <el-form-item>
            <el-tree
              style="margin: 20px 0"
              ref="tree"
              :data="tableData"
              node-key="jurId"
              show-checkbox
              :default-expand-all="false"
              :props="defaultProps"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-tree
              style="margin: 20px 0"
              ref="treeRight"
              :data="mzAppList"
              node-key="jurId"
              show-checkbox
              :default-expand-all="false"
              :props="defaultProps"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-tree
              style="margin: 20px 0"
              ref="treeRights"
              :data="cityList"
              node-key="jurId"
              show-checkbox
              :default-expand-all="false"
              :props="defaultProps"
            />
          </el-form-item>
        </el-col>
      </el-row>
      
      
    </el-form>

    <span slot="footer" class="dialog-footer">
            <el-button @click="closeEditDialog">取消</el-button>
            <el-button type="primary" @click="saveEditForm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import axios from "axios";
import apiBaseUrl from '../../../config/api';

export default {
  components: {},
  data() {
    return {
      roleId: '', // 角色Id
      listQuery: {
        po_id: 0,
        searchMenu: '',
      },
      tableData: [],//所有权限
      sysMenuList: [],//所选权限id
      roleShow: false,
      defaultProps: {
        children: 'children',
        label: 'jurTitle'
      },
      mzAppList:[],
      cityList: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    //查询所有权限
    listData() {
      this.listLoading = true
      const data = {
        po_id: this.listQuery.po_id,
        jur_title: this.listQuery.searchMenu
      }
      axios
        .post(
          `${apiBaseUrl}/admin/jurisdictionlist`,
          data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
        )
        .then(response => {
          // this.tableData = response.data.data.list;
          let data = response.data.data.list;
          for (let i = 0; i < data.length; i++) {
            if (data[i].jurTitle == "小程序权限") {
               this.mzAppList.push(JSON.parse(JSON.stringify(data[i])))
            }if(data[i].jurTitle == "城市权限"){
              this.cityList.push(JSON.parse(JSON.stringify(data[i])))
            }else{
              this.tableData.push(JSON.parse(JSON.stringify(data[i])))
            }
          }
        })
        .catch(error => {
          console.log(error);
        }).finally(() => {
        this.listLoading = false
      });
    },
    init(roleId) {
      this.roleId = roleId;
      const data = {
        po_id: roleId,
      }
      axios
        .post(
          `${apiBaseUrl}/admin/jurisdictionlisttwo`,
          data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
        )
        .then(response => {
          this.sysMenuList =  response.data.data.list;
          this.$refs.tree.setCheckedKeys(this.sysMenuList)
          this.$refs.treeRight.setCheckedKeys(this.sysMenuList)
          this.$refs.treeRights.setCheckedKeys(this.sysMenuList)
        })
        .catch(error => {
          console.log(error);
        });
      this.roleShow = true
    },

    //关闭修改页面
    closeEditDialog() {
      this.sysMenuList = []
      this.roleShow = false
    },
    //确定按钮
    saveEditForm() {
      // let arr1 = this.$refs.tree.getCheckedKeys();
      // let arr2 = this.$refs.tree.getHalfCheckedKeys();
      const pcProject = this.$refs.tree.getCheckedNodes(false, true);
      const appProject = this.$refs.treeRight.getCheckedNodes(false, true);
      const cityProject = this.$refs.treeRights.getCheckedNodes(false, true);
      const allCheckedNodes = [...pcProject,...appProject,...cityProject]
      let idList = allCheckedNodes.map(node => node.jurId);
      let idStr = idList.join(",")
      let data = {
        "po_id": this.roleId,
        "jur_id": idStr
      }
      axios
        .post(
          `${apiBaseUrl}/admin/postaddjur`,
          data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
        )
        .then(response => {
          if (response.data.code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          } else {
            this.$message({
              type: 'error',
              message: '操作失败',
            })
          }
          this.roleShow = false
        })
        .catch(error => {
          console.log(error);
        });
    },
  },

  created() {

  },

  mounted() {
    this.listData()
  },


}


</script>

<style scoped lang="less">
.manage_authority{
  display: inline-block;
}
</style>




// WEBPACK FOOTER //
// src/manager/components/RoleAuthUpdate.vue